
import UiSpinner from "~/components/UI/UiSpinner.vue";

export default {
  name: "UiGlobalLoader",
  components: { UiSpinner },
};
